import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = [ 'element' ]

  remove = () => this.elementTargets.forEach(elem => elem.remove())
}
